import {
    PriceProps,
    FixedPriceType,
    RangePriceType,
    SimplePriceType
} from '@/types/productRecommendations'

const isFixedPrice = (price: any): price is FixedPriceType => price.type === 'fixed'

const isRangePrice = (price: any): price is RangePriceType => price.type === 'range'

const isSimplePrice = (price: any): price is SimplePriceType => 'sales' in price

const FREE_SHIPPING_THRESHOLD = 50

export const qualifiesForFreeShipping = (price?: PriceProps['price']): boolean => {
    if (!price) return false

    if (typeof price === 'number') return price >= FREE_SHIPPING_THRESHOLD

    if (isFixedPrice(price)) {
        return (
            (price.perUnit ?? 0) >= FREE_SHIPPING_THRESHOLD ||
            (price.startingPrice ?? 0) >= FREE_SHIPPING_THRESHOLD ||
            (price.rangeStart ?? 0) >= FREE_SHIPPING_THRESHOLD
        )
    }

    if (isRangePrice(price)) return price.min.sales.value >= FREE_SHIPPING_THRESHOLD

    if (isSimplePrice(price)) return price.sales.value >= FREE_SHIPPING_THRESHOLD

    return false
}
